import { HomeTitle } from './features/home-title';
import { MenuButton } from './features/menu-button';
import { PreLoader } from './features/pre-loader';
import { SearchButton } from './features/search-button';

const menuButton = new MenuButton();
menuButton.init();

const preLoader = new PreLoader();
preLoader.init();

const homeTitle = new HomeTitle();
homeTitle.init();

const searchButton = new SearchButton();
searchButton.init();
